
  import Events from '@/events/Events';
  import StarRatingActionButton from '@/components/StarRatingActionButton';

  export default {
    name: 'OrganizationCard',
    components: {
      StarRatingActionButton,
    },
    filters: {
      truncate(string, value) {
        return string.length > value
          ? string.substring(0, value) + '…'
          : string;
      },
    },
    props: {
      organization: {
        type: Object,
        required: true,
      },
      page: {
        type: Number,
        required: true,
      },
      position: {
        type: Number,
        required: true,
      },
      loggedIn: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    serverCacheKey(props) {
      // Deaktiviere das Caching, wenn der Benutzer eingeloggt ist
      if (props.loggedIn) {
        return false;
      }

      // Ansonsten generiere einen eindeutigen Cache-Schlüssel
      return 'organization-card-' + props.organization.id;
    },
    methods: {
      clickWebhook() {
        this.$emitWithClientData(Events.OrganizationDetailsClicked, {
          organizationId: this.organization.id,
          type: 'OrganizationListing',
          page: this.page,
          position: this.position,
        });
      },
    },
  };
